import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { DEFAULT_LANG, SUPPORTED } from "@/i18n";

export default function NotFoundRedirect() {
  const { lang } = useParams();
  const target = SUPPORTED.includes(lang) ? lang : DEFAULT_LANG;
  return <Navigate to={`/${target}`} replace />;
}
